import { track } from '../analytics/events';
/**
 * This meethod ensure that redirect attempts are restricted to
 * a limitted number of attempts to avoid recursive redirects
 */
export const canAttemptRedirect = () => {
  let redirect = false;
  let attemptsCount = parseInt(sessionStorage.getItem('redirectAtttemptsCount'), 10);
  if (!attemptsCount || attemptsCount < 3) {
    attemptsCount = (attemptsCount || 0) + 1;
    sessionStorage.setItem('redirectAtttemptsCount', attemptsCount);
    redirect = true;
  } else {
    window.setTimeout(() => { sessionStorage.removeItem('redirectAtttemptsCount'); }, 2 * 60 * 1000);
  }
  return redirect;
};
/**
 * Redirects to homepage if redirect attempts haven't been exceeded
 * @param {*} ctx  needed to reference router
 */
export const redirectToHomePage = (ctx) => {
  if (ctx && canAttemptRedirect()) {
    ctx.$router.push({ path: '/', query: ctx.$route.query });
  }
};

/**
 * Ensures that handoff url always routes to mymove
 * @param {*} url
 */
export const validateHandoffUrl = (url) => {
  try {
    const parseUrl = new URL(url);
    if (parseUrl && parseUrl.hostname?.toLowerCase().indexOf('mymove.com') !== -1) {
      return url;
    }
  } catch (e) {
    //
  }
  window.console.error(`Handoff url is invalid. Url: ${url}`);
  track('InvalidHandoffURL', {
    invalidUrl: url,
  });
  return null;
};
